/**
 * Códigos RD SCREEN alinhados a tb_sca_menu / seed 011 — gates de rota no FE.
 * Apenas SCREEN (sem `_EP_`). APIs usam ENDPOINT `*_EP_*` no backend.
 * A autorização efetiva vem de perfil → função (user.authorizations no /auth/me).
 */
export const ROUTE_AUTH = {
  SCA_USER: "SCA_USER_RD",
  SCA_USER_HIST: "SCA_USER_HIST_RD",
  SCA_USERGROUP: "SCA_USERGROUP_RD",
  SCA_USERGROUP_HIST: "SCA_USERGROUP_HIST_RD",
  SCA_PROFILE: "SCA_PROFILE_RD",
  SCA_FUNCTION: "SCA_FUNCTION_RD",
  SCA_COMPANY_ACCESS: "SCA_COMPANY_ACCESS_RD",
  /** Mesmo RD de companhia; licença comercial distinta. */
  SCA_PORTAL_ACCESS: "SCA_COMPANY_ACCESS_RD",

  CAD_COMPANY: "CAD_COMPANY_RD",
  CAD_COUNTERPARTY: "CAD_COUNTERPARTY_RD",
  CAD_CUSTOMER: "CAD_CUSTOMER_RD",
  CAD_TENANT: "CAD_TENANT_RD",
  CAD_MEMBER: "CAD_MEMBER_RD",
  CAD_COST_CENTER: "CAD_COST_CENTER_RD",
  CAD_PROPERTY: "CAD_PROPERTY_RD",
  CAD_LEASE: "CAD_LEASE_RD",
  CAD_FIN_EVENT: "CAD_FIN_EVENT_RD",
  CAD_FIN_OPERATION: "CAD_FIN_OPERATION_RD",
  CAD_IFACE_CONTEXT: "CAD_IFACE_CONTEXT_RD",
  TECH_RPT_CONFIG: "TECH_RPT_CONFIG_RD",
  TECH_WF_CONFIG: "TECH_WF_CONFIG_RD",
  TECH_DOC_TEMPLATE: "TECH_DOC_TEMPLATE_RD",
  /** Mesmo gate SCREEN de Templates (sem inclusão; catálogo por canal). */
  TECH_DOC_NUMBERING: "TECH_DOC_TEMPLATE_RD",
  TECH_DOC_TRIGGER: "TECH_DOC_TRIGGER_RD",
  TECH_REPO_CONFIG: "TECH_REPO_CONFIG_RD",

  CTB_COA: "CTB_COA_RD",
  CTB_EVENT: "CTB_EVENT_RD",
  CTB_OPERATION: "CTB_OPERATION_RD",
  CTB_REPORT: "CTB_REPORT_RD",
  CTB_MANUAL_JE: "CTB_MANUAL_JE_RD",
  CTB_INTEGRATION: "CTB_INTEGRATION_RD",
  CTB_INTEGRATION_AP: "CTB_INTEGRATION_AP",
  CTB_CLOSING: "CTB_CLOSING_RD",
  CTB_CLOSING_AP: "CTB_CLOSING_AP",

  GSF_AP: "GSF_AP_RD",
  GSF_AR: "GSF_AR_RD",
  /** Legado — preferir OWN / ADMIN. */
  GSF_STATEMENT: "GSF_STATEMENT_RD",
  GSF_STATEMENT_OWN: "GSF_STATEMENT_OWN_RD",
  GSF_STATEMENT_ADMIN: "GSF_STATEMENT_ADMIN_RD",
  GSF_CASH_BOOK: "GSF_CASH_BOOK_RD",
  GSF_BANK_LEDGER: "GSF_BANK_LEDGER_RD",
  GSF_BANK_RECON: "GSF_BANK_RECON_RD",
  GSF_FCX: "GSF_FCX_RD",
  GSF_MEMBER_EQUITY: "GSF_MEMBER_EQUITY_RD",
  GSF_VENDOR_ADV: "GSF_VENDOR_ADV_RD",
  GSF_CUSTOMER_ADV: "GSF_CUSTOMER_ADV_RD",
  GSF_DOC_OUTBOX: "GSF_DOC_OUTBOX_RD",
  GSF_RECURRING_EXPENSE_AUDIT: "GSF_RECURRING_EXPENSE_AUDIT_RD",

  ADM_CLIENT: "ADM_CLIENT_RD",
  ADM_CONFIG: "ADM_CONFIG_RD",
  ADM_EMAIL: "ADM_EMAIL_RD",
  ADM_DOC_STORAGE: "ADM_DOC_STORAGE_RD",
  ADM_ASSINATURA: "ADM_ASSINATURA_RD",
  ADM_SEGURANCA: "ADM_SEGURANCA_RD",

  PORTAL_PROFILE: "PORTAL_PROFILE_RD",
  PORTAL_PROPERTY: "PORTAL_PROPERTY_RD",
  PORTAL_STATEMENT: "PORTAL_STATEMENT_RD",
};

/** Submódulo comercial alinhado ao código RD (Portal = pacote único). */
export function submoduleFromAuthRd(cdAuthorization, hintKey = null) {
  if (hintKey === "SCA_PORTAL_ACCESS") return "SCA_PORTAL_ACCESS";
  if (
    hintKey === "GSF_STATEMENT_OWN" ||
    hintKey === "GSF_STATEMENT_ADMIN" ||
    hintKey === "GSF_STATEMENT"
  ) {
    return "GSF_STATEMENT";
  }
  if (hintKey === "GSF_RECURRING_EXPENSE_AUDIT") return "GSF_AP";
  if (hintKey === "TECH_DOC_NUMBERING") return "TECH_DOC_TEMPLATE";
  const raw = String(cdAuthorization || "")
    .trim()
    .toUpperCase();
  if (!raw) return null;
  let code = raw.endsWith("_RD") ? raw.slice(0, -3) : raw;
  if (code.endsWith("_HIST")) code = code.slice(0, -5);
  if (code.startsWith("PORTAL_")) return "PORTAL";
  if (code.startsWith("ADM_")) return null;
  if (code.startsWith("GSF_STATEMENT_")) return "GSF_STATEMENT";
  if (code === "GSF_RECURRING_EXPENSE_AUDIT") return "GSF_AP";
  if (code === "CTB_INTEGRATION_AP") return "CTB_INTEGRATION";
  if (code === "CTB_CLOSING_AP") return "CTB_CLOSING";
  return code || null;
}

/** Mapa estável auth → submódulo para uso em App.jsx. */
export const ROUTE_SUBMODULE = {
  ...Object.fromEntries(
    Object.entries(ROUTE_AUTH)
      .map(([k, v]) => [k, submoduleFromAuthRd(v, k)])
      .filter(([, sub]) => Boolean(sub))
  ),
  GSF_STATEMENT: "GSF_STATEMENT",
  GSF_STATEMENT_OWN: "GSF_STATEMENT",
  GSF_STATEMENT_ADMIN: "GSF_STATEMENT",
  GSF_RECURRING_EXPENSE_AUDIT: "GSF_AP",
};
